import { pluralize } from '@iheartjane/utils';

export function formatProductCount(
  productCount: string | number = 0,
  prefix?: string
) {
  const prefixString = prefix ? `${prefix} ` : '';
  const pluralizedWord = pluralize({
    noun: 'product',
    number: parseInt(productCount.toString()),
    returnValue: 'word',
  });
  return parseInt(productCount.toString()) >= 1000
    ? `${prefixString}1K+ ${pluralizedWord}`
    : `${prefixString}${productCount} ${pluralizedWord}`;
}
